import React from 'react'

const Errorlable = (props) => {

    const {text}=props
  return (
    text?<div>
        <b><label style={{fontSize:"12px",display:"flex",fontWeight:"450",color:"#D32F2F", marginBottom:"0px"}}><p style={{marginRight:"2px",lineHeight:"1.5"}}>*</p>{text}</label></b>
    </div >: null
  
  )
}

export default Errorlable
